import { SET_PREMIUM_PLAN_TO_EDIT } from '../constants';

const initialState = {
	allPlans: [],
};

export function premiumPlans(state = initialState, action) {
	const plansState = { ...state }
	switch (action.type) {
		case SET_PREMIUM_PLAN_TO_EDIT:
			plansState.allPlans = action.plan
			return plansState

		default:
			return state
	}
}
